/* split-test vertical_grid_infinite_scroll */

import './vertical-grid.css';

import './img/blank.png';
